module.exports = __webpack_public_path__ + "img/disbursements.2d23459e.svg";